import React, { useContext, useEffect, useRef } from "react";
import { connect, Provider as ReduxProvider } from "react-redux";
import { ConfigProvider } from "antd";
import { getStore } from "./Store";
import Layout from "./Layout";
import Selectors from "./Selectors";
import ActionCreator from "./ActionCreator";
import * as Cart from "./Contexts/CartContext";
import ErrorBoundary from "./ErrorBoundary";
import "antd/dist/reset.css";
import ActivityIndicator from "./Components/ActivityIndicator";
import * as AppContext from "./AppContext";
import constants from "../src/constants";

if (!constants.debug || typeof window === "undefined") {
  console.log = () => 0;
  console.group = () => 0;
  console.groupEnd = () => 0;
}

export function PageContainer(props) {
  const { pageContext, children, ...extraProps } = props;
  return (
    <ConfigProvider
      theme={{
        hashed: false,
        token: {
          fontFamily: "-apple-system, Noto Sans TC, sans-serif",
          colorPrimary: "#3c3c3c",
          colorPrimaryHover: "#4a4a4a",
        },
        components: {
          Button: {
            borderRadius: 2,
            border: "1px solid transparent",
            primaryShadow: "0 2px 0 rgba(0,0,0,.045)",
          },
          Radio: {
            fontFamily: "Roboto, Noto Sans TC",
          },
          Table: {
            headerBg: "#505050",
            headerColor: "#fff",
            headerBorderRadius: 2,
            headerSplitColor: "none",
            padding: 10,
          },
          Input: {
            borderRadius: 2,
          },
          Modal: {
            contentPadding: 0,
          },
        },
      }}
    >
      <WithPageContext>
        <ErrorBoundary>
          <Layout {...extraProps} seo={pageContext.seo}>
            {props.children}
          </Layout>
        </ErrorBoundary>
      </WithPageContext>
    </ConfigProvider>
  );
}

function WithPageContext({ appActions, children, profile }) {
  const app = useContext(AppContext.Context);
  useEffect(() => {
    (async () => {
      if (!profile) {
        await app.actions.autoLogin();
        // TODO: deprecated
        await appActions.autoLogin({ setToken: app.actions.setToken });
        Cart.Actions.fetchCart();
      }
    })();
  }, [appActions, profile]);

  return children;
}

WithPageContext = connect(
  (state, ownProps) => ({
    lang: Selectors.getLang(state),
    profile: Selectors.getLoginUser(state),
  }),
  ActionCreator
)(WithPageContext);

export function AppRoot(props) {
  // const store = getStore(props.pageContext.initialState)
  const store = useRef(getStore({}));

  return (
    <ReduxProvider store={store.current}>
      <AppContext.Provider {...props}>
        <Cart.Provider>
          {props.children}
          <ActivityIndicator />
        </Cart.Provider>
      </AppContext.Provider>
    </ReduxProvider>
  );
}
